module.exports = __webpack_public_path__ + "static/media/app-brasal-inc-logo.580945a7.png";